export default __webpack_public_path__ + "static/media/guest_11_01_danielle_torres.6c0bd6b5.png";